export function stripHtmlTags(html) {
  return html.replace(/<[^>]*>/g, ' ');
}

export function removeAccents(text) {
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function removePunctuation(text) {
  return text.replace(/[^a-zA-ZÀ-ÿ0-9\s]/g, ' ');
}

export function toLowerCase(text) {
  return text.toLowerCase();
}

export function normalizeWhitespace(text) {
  return text.replace(/\s+/g, ' ').trim();
}

export function tokenize(text) {
  return text.split(' ').filter(word => word.length > 0);
}

export function filterByMinLength(words, minLength) {
  return words.filter(word => word.length > minLength);
}

export function deduplicateWords(words) {
  return [...new Set(words)];
}

export function sortAlphabetically(words) {
  return [...words].sort((a, b) => a.localeCompare(b, 'pt-BR'));
}

export function processText(rawHtml, minLength, options = {}) {
  let text = stripHtmlTags(rawHtml);

  if (options.removeAccents) text = removeAccents(text);
  if (options.removePunctuation) text = removePunctuation(text);
  if (options.toLowerCase) text = toLowerCase(text);

  text = normalizeWhitespace(text);

  const allTokens = tokenize(text);
  let words = filterByMinLength(allTokens, minLength);
  const ignoredCount = allTokens.length - words.length;

  if (options.removeDuplicates) words = deduplicateWords(words);
  if (options.sortAlphabetically) words = sortAlphabetically(words);

  return { words, ignoredCount };
}

export function wordsToPlainText(words) {
  return words.join('\n');
}
